import React, { useContext, useEffect } from 'react'
import { CookiesProvider } from 'react-cookie'

import FrameworkTools from '../../utils/dev/dev-tools'
import { LoadingContext } from '../../utils/contexts/loader-context'
import PageContextProvider from '../../utils/contexts/page-context'
import CountryLegalSettings from '../../utils/helpers/geolocalization/country-legal-settings'
import Header from './header'
import Footer from './footer'
import DynamicSections from './dynamic'
import TwitchPlayer from '../elements/twitch-player'
import NotificationBanner from '../elements/notification-banner'

const Layout = props => {
  const pageContext = props.pageContext
  const dataLayer = props.dataLayer
  const globalData = props.globalData
  const pageData = props.data?.pageData ? props.data.pageData : props.data
  const scrollLock = props.scrollLock
  const staticData = pageContext.content
  const localizations = pageContext.localizations ? pageContext.localizations : []
  const { locale, slug, defaultLocaleTitle, postType } = pageContext
  const { loading, contentLoaded, initLoading } = useContext(LoadingContext)
  const [isInitialLoading, setInitialLoading] = initLoading
  const [isLoading, setLoading] = loading
  const [isContentLoaded, setContentLoaded] = contentLoaded
  let body = ''
  if (typeof document !== `undefined`) {
    body = document.body
  }

  useEffect(() => {
    setInitialLoading(true)
  }, [])

  useEffect(() => {
    setContentLoaded(false)
    setLoading(true)

    // Add body classname based on the page type
    if (typeof document !== `undefined`) {
      const postTypeClass = pageContext.postType ? `post-type-${pageContext.postType}` : 'post-type-pages'
      const loadingClass = 'post-loading'
      const currentPostTypeClass = Object.entries(body.classList).find(([key, value]) => value.startsWith('post-type'))?.[1]
      body.classList.add(loadingClass)
      setTimeout(function () {
        if (currentPostTypeClass) {
          body.classList.remove(currentPostTypeClass)
        }
        body.classList.add(postTypeClass)
        body.classList.remove(loadingClass)
      }, 500)
    }
  }, [props.pageContext])

  // Site Custom theme
  const theme = pageContext.theme ? pageContext.theme.siteTheme : ''
  const headerStyles = theme && theme.header ? theme.header : undefined
  const footerStyles = theme && theme.footer ? theme.footer : undefined
  const newsletterStyles = theme && theme.content && theme.content.Newsletter ? theme.content.Newsletter : undefined
  const buyGameStyles = theme && theme.content && theme.content.BuyGame ? theme.content.BuyGame : undefined
  const themeModifier = props.data?.pageData ? props.data?.pageData?.themeModifier : props.data?.themeModifier
  const customTheme = pageContext.theme && pageContext.theme.customTheme ? pageContext.theme.customTheme : ''
  const themePublished = customTheme && (customTheme.customStylingState === 'published' || ((process.env.GATSBY_ENV === 'dev' || process.env.GATSBY_ENV === 'stg') && customTheme.customStylingState) && customTheme.customStylingClass !== null ? true : false)
  let customStylingToggle = customTheme.customStylingToggle ? true : false
  let customStylingClass = ''
  if (typeof document !== `undefined`) {
    if (themePublished && !customStylingToggle) {
      customStylingClass = customTheme.customStylingClass
      body.classList.add(customStylingClass)
    }
  }

  // General site data
  const brandData = globalData?.brandData
  const seoData = globalData?.seoData?.metadata
  const gameData = globalData?.gameData
  const socialData = globalData?.globalData?.socialLinks
  const ratingsData = globalData?.ratingsData
  const ageGateData = globalData?.ageGateData

  // Localized Strings Data
  const stringsData = globalData.stringsData
  const pageDirectories = globalData.directoriesData

  // Header specific data
  const mainNavData = globalData?.navData?.mainNav
  const ctaData = globalData?.navData?.ctaLinks

  // Dynamic sections specific data
  const newsletterData = globalData?.globalData?.newsletterForm
  const disableBuyGameSection = pageData?.disableBuyGameSection ? pageData.disableBuyGameSection : staticData?.disableBuyGameSection ? staticData.disableBuyGameSection : pageContext?.postType === 'article' ? true : false
  const disableNewsletterSignup = pageData?.disableNewsletterSignup ? pageData.disableNewsletterSignup : staticData?.disableNewsletterSignup ? staticData.disableNewsletterSignup : false
  const bannerData = globalData?.globalData?.notificationBanner;

  // Newsletter List for Iterable
  const newsletterList = dataLayer?.game?.replace(/[' ']/g, '')

  const BuyGame = () => {
    return ''
  }
  const Banner = () => {
    return (
      <NotificationBanner
        data={bannerData}
        className="notification-banner fixed right-0 z-40"
      />
    )
  }

  // Footer specific data
  const footerNavData = globalData.navData && globalData.navData.footerNav
  const footerData = globalData.globalData && globalData.globalData.footer

  return (
    <CookiesProvider>
      <PageContextProvider
        pageGating={ageGateData?.pageGating}
      >
        <CountryLegalSettings
          data={ratingsData}
        />
        <Header
          data={{ brandData, mainNavData, ctaData, socialData, seoData, stringsData, themeModifier, gameData, dataLayer }}
          theme={headerStyles}
          pageContext={{ ...pageContext, pageDirectories }}
          themeModifier={{
            hideMainNav: themeModifier ? themeModifier.hideMainNav : false,
            storeCTALabel: themeModifier ? themeModifier.storeCTALabel : null,
            customTheme: themeModifier ? themeModifier.customTheme : false,
            customNavTitle: themeModifier ? themeModifier.customNavTitle : false,
          }}
          scrollLock={scrollLock}
          contextualNav={props.contextualNav}
        />
        {props.children}
        <DynamicSections
          data={{ gameData, newsletterData, ageGateData, bannerData, stringsData, disableBuyGameSection, disableNewsletterSignup }}
          globalData={globalData}
          pageContext={pageContext}
          globalContext={{ locale, slug, localizations, postType, defaultLocaleTitle, brandData, dataLayer }}
          styling={{ newsletterStyles, buyGameStyles }}
          newsletter={props.customNewsletterContent}
          newsletterForm={props.customNewsletterForm}
          newsletterList={newsletterList}
          buygame={BuyGame}
          banner={Banner}
        />
        <Footer
          data={{ footerNavData, footerData, brandData, socialData, gameData, stringsData, dataLayer }}
          theme={footerStyles}
          pageContext={pageContext}
          customThemeOptions={{
            disableFooter: themeModifier ? themeModifier.disableFooter : false,
            removeFooterSocial: themeModifier ? themeModifier.removeFooterSocial : false,
            removeFooterStoreLinks: themeModifier ? themeModifier.removeFooterStoreLinks : false,
            customTheme: themeModifier ? themeModifier.customTheme : false
          }}
          customFooterContent={props.customFooterContent}
        />
        {process.env.GATSBY_TWITCH_CHANNEL && (
          <TwitchPlayer
            channel={process.env.GATSBY_TWITCH_CHANNEL}
          />
        )}
      </PageContextProvider>
      <FrameworkTools />
    </CookiesProvider>
  )
}

export default Layout
